import classNames from 'classnames';
import React from 'react';

import { Icon, IconTypes } from '@eika/icon';
import { Link, LinkType } from '@eika/link';

import { useConfig } from '../../../defaultConfig';
import useTranslation from '../../../hooks/useTranslation';

import './PaymentLimitsErrorMessage.scss';

type PaymentLimitsErrorMessageProps = {
    message?: string;
    className?: string;
    type?: 'error' | 'warning' | 'attention';
};

const PaymentLimitsErrorMessage: React.FC<PaymentLimitsErrorMessageProps> = ({
    message,
    className,
    type = 'error',
}) => {
    const { paymentLimitsLink } = useConfig();
    const translated = useTranslation();
    return message ? (
        <span
            data-testid="payment-limits-error-message"
            className={classNames('payment-limits-error-message__wrapper', className)}
        >
            <span className={classNames('payment-limits-message sgw-label', type)}>
                <Icon type={IconTypes.UTROPSTEGN_24} />
                <span>
                    {`${message}. `}
                    {paymentLimitsLink && (
                        <Link linkType={LinkType.INLINE} href={paymentLimitsLink.url}>
                            {paymentLimitsLink.text ?? translated.updatePaymentLimits.update}
                        </Link>
                    )}
                </span>
            </span>
        </span>
    ) : null;
};

export default PaymentLimitsErrorMessage;
